module.exports = __webpack_public_path__ + "img/icon-next.6dcd9c69.svg";